import { createFileRoute, Outlet } from '@tanstack/react-router'
// eslint-disable-next-line boundaries/element-types
import { CantileverPage } from 'components/CantileverPage'

export const Route = createFileRoute('/parts')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CantileverPage>
      <Outlet />
    </CantileverPage>
  )
}
